export default __webpack_public_path__ + "slices/main/assets/public/media/leading-the-way-customer-stories@2x.7c0a71c38fd6eaa781d9e6b0e86a7a53.png";